<div class="view-filters-active" *ngIf="selectedOptions.length > 0">
    <div class="total">Filters: {{ selectedOptions.length }}</div>
    <div class="separator" *ngIf="selectedOptions.length > 0">|</div>
    <div class="clear" (click)="clearSelectedFilters()" *ngIf="selectedOptions.length > 0">Clear all</div>
    <div class="selected-filter-container">
        <div class="selected-filter" *ngFor="let option of selectedOptions">
            <div class="text">
                {{ option.categoryName ? option.categoryName + ": " : ""
                }}{{ option.withoutBeautifyDisplayName ? option.displayName : (option.displayName | beautifyDisplayString) }}
            </div>
            <img src="assets/images/common/cancel-hollow.svg" (click)="clearSingleOption(option)" alt="cancel" />
        </div>
    </div>
</div>
